import { render, staticRenderFns } from "./utm-auto.vue?vue&type=template&id=50fe3b24&scoped=true"
import script from "./utm-auto.vue?vue&type=script&lang=js"
export * from "./utm-auto.vue?vue&type=script&lang=js"
import style0 from "./utm-auto.vue?vue&type=style&index=0&id=50fe3b24&prod&scoped=true&lang=css"
import style1 from "./utm-auto.vue?vue&type=style&index=1&id=50fe3b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fe3b24",
  null
  
)

export default component.exports